require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./journal-latest-sydney-townhouse-concepts.json") })
        }
      }, "path---journal-latest-sydney-townhouse-concepts");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---journal-latest-sydney-townhouse-concepts!./.cache/json/journal-latest-sydney-townhouse-concepts.json
// module id = 508
// module chunks = 231608221292675